import { render } from "./PermissionCheckEditor.vue?vue&type=template&id=3a1b2f53"
import script from "./PermissionCheckEditor.vue?vue&type=script&lang=ts"
export * from "./PermissionCheckEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script